var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FrontendIcon",
    width: "70px",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 101.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2 {\n        fill-rule: evenodd;\n        fill: #fff;\n        stroke-width: 0px;\n      }\n\n      .cls-13 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-width: 2px;\n        opacity: 0;\n        animation-name: fadeInAndStayVisible;\n        animation-duration: 2s;\n        animation-fill-mode: forwards;\n        animation-iteration-count: infinite;\n      }\n\n      @keyframes fadeInAndStayVisible {\n        0% {\n          opacity: 0;\n        }\n\n        10%,\n        90% {\n          opacity: 1;\n        }\n\n        100% {\n          opacity: 1;\n        }\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.34,0h116.2c1.84,0,3.34,1.5,3.34,3.34v76.98c0,1.84-1.5,3.34-3.34,3.34H3.34c-1.84,0-3.34-1.5-3.34-3.34V3.34C0,1.5,1.5,0,3.34,0h0ZM46.29,88.27h30.3c.08,5.24,2.24,9.94,8.09,13.63h-46.48c4.68-3.39,8.11-7.51,8.09-13.63h0ZM61.44,72.41c2.37,0,4.29,1.92,4.29,4.29s-1.92,4.29-4.29,4.29-4.29-1.92-4.29-4.29c0-2.37,1.92-4.29,4.29-4.29h0ZM10.05,6.29h102.79c1.63,0,2.95,1.33,2.95,2.95v57.52c0,1.62-1.33,2.95-2.95,2.95H10.05c-1.62,0-2.95-1.33-2.95-2.95V9.24c-.01-1.62,1.32-2.95,2.95-2.95h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0s"
    },
    d: "M16.36,36.66l11.14-5.74v1.66l-9.38,4.7v.05l9.38,4.7v1.66l-11.14-5.74v-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0.1s"
    },
    d: "M33,27.52v6.77h7.82v-6.77h2.11v16.18h-2.11v-7.58h-7.82v7.58h-2.09v-16.18h2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0.2s"
    },
    d: "M49.63,29.29h-4.92v-1.78h11.98v1.78h-4.94v14.4h-2.11v-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0.3s"
    },
    d: "M72.12,36.59c-.12-2.26-.26-4.97-.24-6.98h-.07c-.55,1.9-1.22,3.91-2.04,6.14l-2.86,7.85h-1.58l-2.62-7.7c-.77-2.28-1.42-4.37-1.87-6.29h-.05c-.05,2.02-.17,4.73-.31,7.15l-.43,6.94h-1.99l1.13-16.18h2.66l2.76,7.82c.67,1.99,1.22,3.77,1.63,5.45h.07c.41-1.63.98-3.41,1.7-5.45l2.88-7.82h2.66l1.01,16.18h-2.04l-.41-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0.4s"
    },
    d: "M77.78,27.52h2.09v14.43h6.91v1.75h-9v-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0.5s"
    },
    d: "M87.26,44.65l6.7-17.4h1.63l-6.72,17.4h-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    style: {
      animationDelay: "0.6s"
    },
    d: "M108.24,37.98l-11.14,5.71v-1.66l9.46-4.7v-.05l-9.46-4.7v-1.66l11.14,5.71v1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/FRONTEND.44d7acf55a44882bfac20279bce21072.svg";
export { ForwardRef as ReactComponent };